var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvisionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15712",
    "data-name": "Group 15712",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1778",
    "data-name": "Rectangle 1778",
    width: 52,
    height: 52,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15711",
    "data-name": "Group 15711",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19207",
    "data-name": "Path 19207",
    d: "M47.521,0H4.737A4.737,4.737,0,0,0,0,4.737V47.521a4.737,4.737,0,0,0,4.737,4.737H47.521a4.737,4.737,0,0,0,4.737-4.737V4.737A4.737,4.737,0,0,0,47.521,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19208",
    "data-name": "Path 19208",
    d: "M463.891,491.916a3.146,3.146,0,1,0-3.192-3.146,3.156,3.156,0,0,0,3.192,3.146m-6.619,16.845a10.8,10.8,0,0,0-.282,2.363c0,2.77,1.5,4.609,4.695,4.609,2.648,0,4.794-1.572,6.34-4.111l-.944,3.787h5.257l3-12.052c.751-3.051,2.206-4.635,4.413-4.635a2.627,2.627,0,0,1,2.817,2.864,5.624,5.624,0,0,1-.235,1.69l-1.549,5.54a8.327,8.327,0,0,0-.328,2.347c0,2.63,1.549,4.553,4.788,4.553,2.77,0,4.976-1.783,6.2-6.055l-2.065-.8c-1.033,2.862-1.925,3.38-2.629,3.38s-1.08-.469-1.08-1.407a6.23,6.23,0,0,1,.235-1.456l1.5-5.4a11.9,11.9,0,0,0,.516-3.423c0-4.037-2.441-6.144-5.4-6.144-2.77,0-5.587,2.5-6.995,5.128l1.032-4.72h-8.027l-1.127,4.157h3.756l-2.313,9.259c-1.816,4.037-5.152,4.1-5.571,4.009-.687-.155-1.127-.416-1.127-1.31a8.853,8.853,0,0,1,.329-2.148L466,494.823h-8.92l-1.127,4.157h3.708l-2.394,9.781",
    transform: "translate(-446.426 -475.474)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisionLogo);
export default __webpack_public_path__ + "static/media/invision-logo.2bdef86c59476e3a638b99e0b48de712.svg";
export { ForwardRef as ReactComponent };